// extracted by mini-css-extract-plugin
module.exports = {"gameAreaMask":"GameAreaMask_gameAreaMask__A8Xj2","maskText":"GameAreaMask_maskText__3ui8B"};